const LAST_RELOAD_AT_KEY = "pf_preload_error_reload_at";
/** Long enough for the reload to pick up the new chunks; short enough that an unrelated later failure still reloads. */
const RELOAD_COOLDOWN_MS = 30_000;

const readLastReloadAt = (): number => {
  try {
    return Number(sessionStorage.getItem(LAST_RELOAD_AT_KEY)) || 0;
  } catch {
    return 0; // storage blocked: nothing to compare against, same as a tab that never reloaded
  }
};

const rememberReloadNow = () => {
  try {
    sessionStorage.setItem(LAST_RELOAD_AT_KEY, String(Date.now()));
  } catch {
    // storage blocked: worst case the cooldown is not remembered and a later failure reloads again
  }
};

/**
 * After a deploy, Firebase Hosting no longer serves the old hashed chunk files. A tab left open since before the
 * deploy then fails to dynamically import a lazy screen (`App.tsx`), and Vite fires this event instead of letting
 * the import's rejection reach the router (PATIENT-WEBAPP-P). Reloading once picks up the new chunks. Guarded by a
 * cooldown: a chunk still missing shortly after a reload points to something else being wrong, so that error is
 * left to reach the route's error boundary instead of reloading forever.
 */
export const reloadOnMissingChunk = () => {
  window.addEventListener("vite:preloadError", (event) => {
    if (Date.now() - readLastReloadAt() < RELOAD_COOLDOWN_MS) return;
    event.preventDefault();
    rememberReloadNow();
    window.location.reload();
  });
};
